import { supabase } from './supabase';

/**
 * Where on the site a submission came from — stored in the `source` column
 * of the single `submissions` table. Add new values here for future forms
 * (e.g. 'blog_newsletter').
 */
export type SubmissionSource =
  | 'hero_request_phone'
  | 'hero_request_whatsapp'
  | 'membership_page_request_phone'
  | 'membership_page_request_whatsapp'
  | 'callback_bar'
  | 'membership_application'
  | 'members_only_invite'
  | 'footer_newsletter';

export type SubmissionInput = {
  source: SubmissionSource;
  name?: string;
  email?: string;
  phone?: string;
  /** Everything else the form collected (destination, needs, dates, tier…) */
  details?: Record<string, unknown>;
};

export const SUBMISSION_ERROR = 'Something went wrong — please try again, or reach us on WhatsApp.';

/** Saves one submission. Resolves to true on success, false on failure. */
export async function saveSubmission({ source, name, email, phone, details = {} }: SubmissionInput): Promise<boolean> {
  try {
    const { error } = await supabase.from('submissions').insert({
      source,
      name: name?.trim() || null,
      email: email?.trim() || null,
      phone: phone?.trim() || null,
      details,
      page: typeof window !== 'undefined' ? window.location.pathname : null,
      locale: typeof document !== 'undefined' ? document.documentElement.lang || null : null,
    });
    if (error) {
      console.error('Submission failed:', error.code, error.message, error.details, error.hint);
      return false;
    }
    return true;
  } catch (err) {
    console.error('Submission failed:', err);
    return false;
  }
}
